import auth from "./auth";
import app from "./app";
import theme from "./theme";
import notifications from "./notifications";
import profile from "./profile";
import data from "./data";

export const MatjrahAPI = {
	auth, app, theme, notifications, profile, data
};